import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
type PhoneButtonProps = {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

// Padding and icon are em-based so the whole button scales with its fluid font size.
const sizes = {
  sm: 'fs-btn-sm px-[1.35em] py-[0.75em] gap-[0.6em]',
  md: 'fs-sm px-[1.8em] py-[0.95em] gap-[0.65em]',
  lg: 'fs-btn px-[1.75em] py-[1em] gap-[0.65em]'
};
export function PhoneButton({
  label,
  size = 'md',
  className = ''
}: PhoneButtonProps) {
  const text = label ?? business.phoneDisplay;
  const base = `inline-flex items-center whitespace-nowrap rounded-full bg-gold-gradient font-label font-medium uppercase leading-none tracking-[0.16em] text-ink shadow-[0_0.4em_1.6em_-0.6em_rgba(212,162,76,0.6)] ${sizes[size]} ${className}`;
  const icon = <PhoneIcon className="h-[1.1em] w-[1.1em] shrink-0" aria-hidden="true" data-id="element-57" data-mp="xe7qfokndtbz" />;
  if (!business.phoneHref) {
    return <span className={`${base} cursor-default`} aria-disabled="true" title="Phone number coming soon" data-id="element-58" data-mp="skmqvs3eorao">
        {icon}
        {text}
        {label && <span className="sr-only" data-id="element-59" data-mp="g8dqvuv08r4n"> — phone number coming soon</span>}
      </span>;
  }
  return <a href={business.phoneHref} className={`${base} transition-[filter,transform] duration-150 ease-out hover:brightness-110 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-night`} data-id="element-60" data-mp="1jr9zopqbrbb">
      {icon}
      {text}
    </a>;
}